module.exports = ".wp-pagination-wrapper .pagination,\n.wp-pagination-wrapper .wp-pagination-text-wrapper {\n  margin: 20px 0; }\n\n.wp-pagination-wrapper .wp-pagination-text-wrapper {\n  height: 30px;\n  line-height: 30px;\n  margin-left: 10px;\n  padding-left: 10px;\n  border-left: 1px solid #e7ecf1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/woopa-ui/pagination/pagination.component.scss
// module id = 591
// module chunks = 8